import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const refreshAccessToken = async () => {
  const response = await axios.post(
    `${API_URL}/auth/refresh`,
    {},
    { withCredentials: true },
  );
  return response.data;
};

export default refreshAccessToken;

